/*! Bliss · Cart drawer (vanilla, no deps).
   - Click on [data-bliss-cart-toggle] toggles drawer instead of navigating to /cart.
   - Quantity +/- and Remove buttons hit /cart/change.js and re-fetch the drawer.
   - Listens for shopify:cart:add (Dawn add-to-cart) + hooks fetch to /cart/add.js.
   Fixed: section JSON is now parsed with JSON.parse (the old regex had lost its
   backslashes — `s*`/`[sS]*?` matched literal s/S, so the drawer never updated).
   refresh() now swaps innerHTML of the stable outer element, and close/overlay
   are delegated, so listeners survive the swap.
*/
(function(){
  var drawer, overlay;
  function ready(fn){ if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  function open(){ if (!drawer) return; drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function close(){ if (!drawer) return; drawer.classList.remove('is-open'); document.body.style.overflow = ''; }
  ready(function(){
    drawer = document.querySelector('.bliss-cart-drawer');
    if (!drawer) return;
    overlay = drawer.querySelector('[data-cart-overlay]');

    // Header bag link → drawer toggle.
    var trig = document.querySelector('[data-bliss-cart-toggle]');
    if (trig) trig.addEventListener('click', function(e){ e.preventDefault(); open(); });

    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') close(); });

    // All in-drawer interactions delegated on the (stable) drawer element so they
    // survive innerHTML swaps in refresh(): close, overlay, qty +/-, remove.
    drawer.addEventListener('click', function(e){
      var t = e.target;
      if (t.closest('[data-cart-close]') || t.closest('[data-cart-overlay]')) {
        e.preventDefault(); close(); return;
      }
      var qtyBtn = t.closest('[data-cart-qty]');
      var removeBtn = t.closest('[data-cart-remove]');
      if (qtyBtn) {
        e.preventDefault();
        var key = qtyBtn.getAttribute('data-key');
        var item = drawer.querySelector('[data-cart-item][data-key="' + key + '"]');
        var input = item && item.querySelector('[data-cart-qty-input]');
        if (!input) return;
        var v = Math.max(0, parseInt(input.value, 10) + (qtyBtn.getAttribute('data-cart-qty') === '+1' ? 1 : -1));
        change(key, v);
      } else if (removeBtn) {
        e.preventDefault();
        change(removeBtn.getAttribute('data-cart-remove'), 0);
      }
    });

    // Intercept native product-form submits so add-to-cart opens the drawer
    // instead of navigating to /cart. Falls back to a native submit on any
    // failure, so add-to-cart can never break.
    document.addEventListener('submit', function(e){
      var form = e.target;
      if (!form || !form.getAttribute) return;
      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;
      e.preventDefault();
      var data = new FormData(form);
      // Uses the fetch hook below to open the drawer on success.
      fetch('/cart/add.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } })
        .then(function(r){ if (!r.ok) throw new Error('add failed'); })
        .catch(function(){ form.submit(); });
    }, true);

    // Add-to-cart hook (Dawn fires shopify:cart:add via product-form custom element).
    document.addEventListener('shopify:cart:add', function(){ refresh().then(open); });
    // Fallback: hook fetch to /cart/add.js
    var origFetch = window.fetch;
    window.fetch = function(url){
      var p = origFetch.apply(this, arguments);
      try {
        var u = typeof url === 'string' ? url : (url && url.url) || '';
        if (u.indexOf('/cart/add') !== -1) p.then(function(){ refresh().then(open); });
      } catch (_) {}
      return p;
    };
  });

  function change(key, qty){
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({id: key, quantity: qty}),
    }).then(refresh);
  }

  // Pull fresh drawer markup via the Section Rendering API and swap the drawer's
  // inner content, keeping the outer <cart-drawer> element and its listeners.
  function refresh(){
    return fetch('/?sections=cart-drawer', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(data){
        var htmlStr = data && data['cart-drawer'];
        if (!htmlStr) return;
        var tmp = document.createElement('div'); tmp.innerHTML = htmlStr;
        var fresh = tmp.querySelector('.bliss-cart-drawer');
        if (!fresh || !drawer) return;
        var wasOpen = drawer.classList.contains('is-open');
        drawer.innerHTML = fresh.innerHTML;
        drawer.className = fresh.className + (wasOpen ? ' is-open' : '');
        overlay = drawer.querySelector('[data-cart-overlay]');
      })
      .catch(function(){});
  }
})();
